import { render } from "./EmotionalGapBadge.vue?vue&type=template&id=0adfc2a7&scoped=true"
import script from "./EmotionalGapBadge.vue?vue&type=script&lang=js"
export * from "./EmotionalGapBadge.vue?vue&type=script&lang=js"

import "./EmotionalGapBadge.vue?vue&type=style&index=0&id=0adfc2a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0adfc2a7"]])

export default __exports__